import Axios from "axios";

export const axios = Axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_PROD_API_URL
      : process.env.REACT_APP_API_URL,
  withCredentials: true,
});
